import { OptionsObject, SnackbarMessage, useSnackbar } from "notistack";

type MessageOption = {
  content: SnackbarMessage;
  style?: React.CSSProperties;
}

export type AntDMessage = {
  success: (options: MessageOption | string) => void;
  error: (options: MessageOption | string) => void;
  info: (options: MessageOption | string) => void;
  warning: (options: MessageOption | string) => void;
}

const useMessage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const show = (msg: SnackbarMessage, variant: OptionsObject["variant"], style: React.CSSProperties = {}) => {
    enqueueSnackbar(msg, {
      anchorOrigin: { vertical: "top", horizontal: "center" },
      style: style,
      autoHideDuration: 3000,
      variant
    });
  };
  return {
    success: (options: MessageOption | string) => {
      options = normalizeOption(options);
      show(options.content, "success", options.style);
    },
    error: (options: MessageOption | string) => {
      options = normalizeOption(options);
      show(options.content, "error", options.style);
    },
    info: (options: MessageOption | string) => {
      options = normalizeOption(options);
      show(options.content, "info", options.style);
    },
    warning: (options: MessageOption | string) => {
      options = normalizeOption(options);
      show(options.content, "warning", options.style);
    }
  };
};

function normalizeOption(options: string | MessageOption): MessageOption {
  if (typeof options === "string") {
    return {
      content: options,
    };
  }
  return options;
}

export default useMessage;
